import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Badge, Button, Table } from "reactstrap";
import "../../assets/css/--component-dashboard.css";
import imageDone from "../../assets/images/step-done.png";
import imagePending from "../../assets/images/step-pending.png";
import imageUpcoming from "../../assets/images/step-upcoming.png";
import wellcomeIcon from "../../assets/images/icon-wellcome.png"
import reOrderIcon from "../../assets/images/Reorder.png";
import { getOrderlist, formatDate, applyLocalTimezone, orderTimeDiff, addCartReOrder } from "../../helper/backend-methods";
import { onOrderStatusUpdate } from "../../helper/signalr-service";
import AppLoader from "../../components/AppLoader";
import { customToast } from "../../components/customToast";
function Dashboard(props) {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState({});
  const [orderedProducts, setOrderedProducts] = useState([]);
  const [activeProducts, setActiveProducts] = useState([]);
  const [sortOrder, setSortOrder] = useState("desc");
  const STATUS_FLOW = [
    {
      key: "preparing",
      currentWhen: ["Preparing", "Ready For Pickup", "Order Picked Up"],
      timeField: "OrderPreparingAt",
    },
    {
      key: "ready_pickup",
      currentWhen: ["Ready For Pickup", "Order Picked Up"],
      timeField: "ReadyForPickupAt",
    },
    {
      key: "pickup",
      currentWhen: ["Order Picked Up"],
      timeField: "OrderPickedUpAt",
    },
  ];
  const STATUS_NOT_INCLUDE = ["Order Picked Up", "Delivered", "Cancelled"];

  const progress = [
    {
      key: "preparing",
      title: "Order Received & Preparing",
      time: "-",
      done: false,
      completed: false,
      status: "current",
    },
    {
      key: "ready_pickup",
      title: "Ready For Pickup",
      time: "-",
      done: false,
      completed: false,
      status: "upcoming",
    },
    {
      key: "pickup",
      title: "Order Picked Up",
      time: "-",
      done: false,
      status: "upcoming",
    },
  ];

  const handleSort = () => {
    const newOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newOrder);

    const sorted = [...orderedProducts].sort((a, b) => {
      const dateA = new Date(a.OrderDate.split("—")[0].trim());
      const dateB = new Date(b.OrderDate.split("—")[0].trim());
      return newOrder === "asc" ? dateA - dateB : dateB - dateA;
    });

    setOrderedProducts(sorted);
  };

  const orderTimes = ({ startTime, endTime }) => {
    const start = new Date(applyLocalTimezone(startTime));
    const end = new Date(applyLocalTimezone(endTime));

    // Format both times to 12-hour AM/PM format
    const options = { hour: "numeric", minute: "numeric", hour12: true };
    const startFormatted = start.toLocaleTimeString([], options).toUpperCase();
    const endFormatted = end.toLocaleTimeString([], options).toUpperCase();

    return (
      <span>
        {startFormatted} - {endFormatted}
      </span>
    );
  };

  const setUpProgress = (order, key) => {
    const _progress = JSON.parse(JSON.stringify(progress));

    STATUS_FLOW.forEach((step, index) => {
      const p = _progress.find((x) => x.key === step.key);
      if (step.currentWhen.includes(order.CurrentStatus)) {
        if (!_progress.some((x) => x.status === "current")) {
          p.status = "current";
        }
        if (order[step.timeField]) {
          p.time = formatDate(order[step.timeField]);
        }
        p.done = true;
        p.completed = true;
      }
    });

    return _progress;
  };

  const getOrder = () => {
    setLoading(true);
    localStorage.getItem("userinfo") && setUser(JSON.parse(localStorage.getItem("userinfo")));
    getOrderlist({ orderStatus: "all" })
      .then(({ data }) => {
        if (data.Status) {
          const orders = data.Data.OrderList.map((o) => {
            o.OrderDate = formatDate(o.OrderDate);
            return o;
          }).sort((a, b) => a.OrderNo.localeCompare(b.OrderNo, undefined, { numeric: true })); // Sort by ID descending
          setOrderedProducts(orders);
          const activeOrders = orders.filter((o) => !STATUS_NOT_INCLUDE.includes(o.CurrentStatus));
          activeOrders.forEach((order) => {
            order.progress = setUpProgress(order);
            if (order.Status == "Preparing" || order.Status == "Received") {
              order.estimatedTime = orderTimeDiff({
                startTime: order?.OrderPreparingAt,
                endTime: order?.EstimatedEndTime,
                leverages: order.OrderLeverages,
              });
            } else if (order.Status == "ReadyForPickup") {
              order.estimatedTime = orderTimeDiff({
                startTime: order?.EstimatedEndTime,
                endTime: order?.EstimatedEndTime,
                leverages: order.OrderLeverages,
              });
            } else {
              order.estimatedTime = orderTimeDiff({
                startTime: order?.EstimatedStartTime,
                endTime: order?.EstimatedEndTime,
                leverages: order.OrderLeverages,
              });
            }

            order.orderTime = orderTimes({ startTime: order?.EstimatedStartTime, endTime: order?.EstimatedEndTime });
          });
          setActiveProducts(activeOrders);
        }
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };

  const reOrder = ((_order) => {
    addCartReOrder({ OrderId: _order.OrderId }).then(({ data }) => {
      if (data.Status) {
        customToast.success("", data.Message,'/openCart');
      }
    }).catch((ex) => {
      console.log(ex);
    })
  });

  useEffect(() => {
    getOrder();
    return onOrderStatusUpdate(() => {
      getOrder();
    });
  }, []);

  return (
    <div id="main-dashboard" className="mt-5 ms-4">
      <div className="grill-title-box">
        <h1 className="fs-36 text-blakish fw-600 main-title">Welcome back, {user?.FullName} <img src={wellcomeIcon} width={52} height={52}/></h1>
      </div>

      <p className="text-gray fs-16">Ready for some delicious country cooking?</p>
      <div className="order-status-wrapper">
        <Row className="align-items-start gx-4">
          <Col md={12}>
            <div className="orders-header d-flex justify-content-between align-items-center mb-3">
              <div className="title d-flex align-items-center">
                <h6 className="m-0 fs-20 text-blakish">Current Orders</h6>
                {activeProducts.length > 0 && (
                  <div className="ms-3">
                    <span className="active-dot" aria-hidden />
                    <span className="active-count"> {String(activeProducts.length).padStart(2, "0")} Active Orders</span>
                  </div>
                )}
              </div>
              <a className="view-all-link fs-14 fw-600" href="/account/current-orders">
                VIEW ALL CURRENT ORDERS
              </a>
            </div>
          </Col>
          {/* Left card */}
          <div className="dashboard-view-order">
            {activeProducts.length > 0 && (
              <div>
                <Card className="order-card">
                  <CardBody>
                    <div className="order-row">
                      <div className="order-left w-50">
                        <h6 className="order-label m-0 fs-16 text-black mb-2">Order No.</h6>
                        <div className="order-value text-gray fs-18">#{activeProducts[0]?.OrderNo}</div>
                      </div>
                      <div className="order-right w-50">
                        <h6 className="order-label m-0 fs-16 text-black mb-2">Status</h6>
                        <div className={`status-badge ${activeProducts[0].CurrentStatus.toLowerCase().replace(/ /g, "")}`}>
                          <i className="ri-time-line"></i> {activeProducts[0]?.CurrentStatus}
                        </div>
                      </div>
                    </div>

                    <span className="separator my-3" />

                    <div className="order-details d-flex justify-content-between">
                      <h6 className="order-label m-0 fs-16 text-black w-50">Order Details</h6>
                      <div className="order-items w-50">
                        {activeProducts[0]?.productOrderDTO.map((it, idx) => (
                          <div key={idx} className="order-item text-gray fs-16">
                            {it.Quantity} <span className="mx-1">x</span> {it.ProductName}
                          </div>
                        ))}
                      </div>
                    </div>

                    <span className="separator my-3" />

                    <div className="d-flex justify-content-between">
                      <div className="w-50">
                        <h6 className="order-label m-0 fs-16 text-black mb-2">Total</h6>
                        <div className="order-value text-gray fs-16">${activeProducts[0]?.TotalAmount}</div>
                      </div>
                      <div className="w-50">
                        <h6 className="order-label m-0 fs-16 text-black mb-2">Estimated Time</h6>
                        <div className="order-value text-gray fs-16">{activeProducts[0]?.estimatedTime}</div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            )}

            {/* Right timeline */}
            {activeProducts.length > 0 && (
              <div className="mt-3 mt-md-0">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <h5 className="mb-1 fs-24 text-blakish">Order Progress</h5>
                    <div className="text-gray fs-18">
                      The delivery of your order is estimated at <span className="estimate-time">{activeProducts[0]?.orderTime}</span>
                    </div>
                  </div>
                </div>

                <div className="timeline-wrapper">
                  <div className="timeline-line" />

                  {/* steps */}
                  <div className="timeline-steps d-flex justify-content-between">
                    {activeProducts[0]?.progress.map((step, idx) => (
                      <div key={step.key} className="timeline-step text-center">
                        <div className={`step-circle ${step.completed ? "completed" : step.done ? "done" : "pending"}`}>
                          <img
                            src={step.completed ? imageDone : step.status === "current" ? imagePending : imageUpcoming}
                            alt={step.title}
                            className="step-icon"
                          />
                        </div>

                        <div
                          className={`step-title ${step.completed ? "completed-text" : step.done ? "done-text" : step.status === "current" ? "pending-text" : ""
                            }`}
                        >
                          {step.title}
                        </div>
                        <div className="step-time fs-16 text-gray">{step.time}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>

          {activeProducts.length === 0 && (
            <Row>
              <Col>
                {loading ? (
                  <div className="loader-center">
                    <AppLoader />
                  </div>
                ) : (
                  <div className="no-active-products text-center">
                    <h6 className="fs-20">No Active Orders</h6>
                    <p className="text-gray">You have no active orders at the moment.</p>
                  </div>
                )}
              </Col>
            </Row>
          )}
        </Row>
      </div>

      <div className="recent-orders-wrapper mt-4">
        <div className="orders-header d-flex justify-content-between align-items-center mb-3">
          <h6 className="m-0 fs-20">Recent Orders</h6>
          <a href="/account/order-history" className="view-all-link fs-14 fw-600">
            VIEW ALL ORDERS
          </a>
        </div>

        <div className="table-responsive recent-orders-table">
          <Table hover className="align-middle mb-0">
            <thead>
              <tr>
                <th>Order No</th>
                <th onClick={handleSort} className="sortable">
                  Date & Time <i className={`ri-arrow-up-down-line fs-16 fw-400 ${sortOrder}`} />
                </th>
                <th>Items</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {orderedProducts.map((order, idx) => (
                <tr key={idx}>
                  <td>#{order.OrderNo}</td>
                  <td>{order.OrderDate}</td>
                  <td className="w-50">
                    {order?.productOrderDTO
                      .map((p) => p?.ProductName)
                      .filter(Boolean)
                      .join(", ")}
                  </td>
                  <td>
                    <span className={`status ${order.CurrentStatus.toLowerCase().replace(/ /g, "")}`}>
                      {order.CurrentStatus.toLowerCase() === "order picked up" ? "Delivered" : order.CurrentStatus}
                    </span>
                  </td>
                  <td>
                    <button className="reorder-btn border-none d-flex align-items-center gap-1" onClick={() => reOrder(order)} >
                      <img src={reOrderIcon} alt="Reorder" /> REORDER
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
